module.exports = __webpack_public_path__ + "media/books/BooksFocus2-58a226ff.jpg";